<template>
    <div class="search-result-box">
        <div class="position">
            <!-- search  -->
            <div class="search-box" @click="triggerSearch">
                <div class="search">
                    <div>
                        <div class="iconfont icon-sousuo1" v-if="!option.search"></div>
                        <div class="text">{{ option.search ? option.search : '搜索商品' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="goods_list">
            <div  v-for="(item, index) in list">
                <router-link class="goods_item"
                    :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                    <div class="image_box">
                        <img v-lazy="item.goods_image"/>
                    </div>
                    <div class="right_box">
                        <div class="goods-name"> {{ item.goods_name }}</div>
                        <div class="first_row">
                            <div class="sales">已售
                                {{ item.goods_sales }}
                            </div>
                            <div class="selling_point" v-if="item.percentage == 10 && item.percentage_eduction > 0">
                                {{ item.percentage_eduction }}%OFF
                            </div>
                        </div>
                        <div class="sales_initial">{{ item.selling_point ? item.selling_point : '' }}</div>
                        <div class="third_row">
                            <div class="price-box">
                                <span class="min-price">${{ item.goods_price }}</span>
                                <span class="line-price">市场价 <span>${{ item.line_price }}</span> </span>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
export default {
    name: 'SearchList',
    data() { //默认数据
        return {
            noresult: false, //是否有数据
            isHasMore: true,
            isLoading: false,
            showView: true, // 列表显示方式
            sortStatus: 'desc', //排序方式
            option: {}, // 当前页面参数
            list: [], // 商品列表数据
            sortType: 'all', // 排序类型
            sortPrice: false, // 价格从低到高
            current_page: 1,
            last_page: 1,
        }
    },
    created() { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
    },
    mounted() { //视图加载完成执行
        let _this = this;
        _this.option = _this.$route.query;
        _this.getGoodsList();
    },
    methods: { //页面方法

        /**
         * 获取商品列表
         * @param {bool} isPage 是否分页
         * @param {number} page 指定的页码
         */
        getGoodsList(page = 1) {
            let _this = this;
            _this._get('index.index/search', {
                search: _this.option.search || '',
            }, result => {
                _this.list = result.searchok;
                _this.isLoading = false;
                _this.loading.hide();
            });

            _this._get("goods/searchLog", {
                keywords: _this.option.search || '',
            }, result => {
            })
        },

        /**
         * 切换排序方式
         */
        switchSortType(type) {
            let _this = this,
                newSortType = type,
                newSortPrice = newSortType === 'price' ? !this.sortPrice : true;
            _this.setData({
                list: [],
                sortType: newSortType,
                sortPrice: newSortPrice,
                sortStatus: newSortPrice ? 'asc' : 'desc',
            });
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this.getGoodsList();
        },

        /**
         *  触底加载
         */
        onInfinite: function () {
            if (this.current_page >= this.last_page) {
                this.isLoading = false;
                this.isHasMore = false;
                return false;
            }
            this.isLoading = true;
            this.isHasMore = true;
            this.getGoodsList(this.current_page + 1);
        },

        // 商品搜索
        triggerSearch() {
            let _this = this;
            _this.$router.go(-1);
        },

    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
        _this.loading.hide();
    }
}
</script>
<style lang="scss" scoped>
@import "list.scss";
</style>
